<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<mat-card>
  <mat-card-content>

    <div style="text-align: left; width: 69%; display: inline-block">
      <div><span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span></div>
      <div>
        <h3>Imported transactions for approval</h3>
      </div>
    </div>

    <div style="text-align: right; width: 30%; display: inline-block">

      <div style="display: inline-block">
        <h3>SUM: {{transactionSum}}</h3>
      </div>

      <div style="display: inline-block; margin-left: 10px;">
        <button mat-raised-button type="submit" color="primary" [class.spinner]="isApproving"
                [disabled]="isLoading || transactions.length == 0" (click)="approveTransactions()">Approve all
        </button>
      </div>


    </div>

    <table mat-table matSort [dataSource]="transactions" class="mat-elevation-z8" style="width: 100%;">

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <ng-container matColumnDef="counterAccount">
        <th mat-header-cell *matHeaderCellDef style="width: 250px;"></th>
        <td mat-cell *matCellDef="let element; dataSource: transactions">
          <div>{{element.counterAccountName}}</div>
          <div style="font-size: .8em; font-family: monospace">{{element.counterAccount}}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="statementDate">
        <th mat-header-cell *matHeaderCellDef style="width: 100px;">Date</th>
        <td mat-cell *matCellDef="let element"> {{ element.statementDate | date:'dd.MM.yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="reference">
        <th mat-header-cell *matHeaderCellDef style=""> Reference </th>
        <td mat-cell *matCellDef="let element;dataSource: transactions">
          <div class="txn-description">{{element.reference}}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef style=""> Description </th>
        <td mat-cell *matCellDef="let element;dataSource: transactions">
          <div class="txn-description">{{element.description}}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef style="width: 50px; text-align: right;"> Amt. </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;">

            {{element.amount.toFixed(2)}}

        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef style="width: 80px; text-align: right;"> Amt. </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;">

          <mat-icon style="color: forestgreen; cursor:pointer;" (click)="approveTransaction(element.id)">check</mat-icon>
          &nbsp;
          <mat-icon style="color: red; cursor:pointer;" (click)="deleteTransaction(element.id)">delete</mat-icon>

        </td>
      </ng-container>



      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="txn-row"></tr>
    </table>
  </mat-card-content>


</mat-card>
